import { format, isValid, parseISO } from 'date-fns';

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Convert `yyyy-MM-dd` (from API / filters) to Date for pickers. */
export function isoDateStringToDate(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (!ISO_DAY.test(s)) return null;
  const d = parseISO(`${s}T12:00:00`);
  return isValid(d) ? d : null;
}

/** Convert picker value to `yyyy-MM-dd` for form state. */
export function dateToIsoDateString(date) {
  if (date == null || !isValid(date)) return '';
  return format(date, 'yyyy-MM-dd');
}
